// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__2_bT6","bookingInfo":"BookingTimeInfo_bookingInfo__CYJh4","dateSection":"BookingTimeInfo_dateSection__3l5Pl"};